export type EditorSelectionSource =
  | "user"
  | "user_click"
  | "unity_selection"
  | "preview"
  | "refresh"
  | "programmatic"
  | null
  | undefined;

export function isTransientFigmaSelectionSource(
  source: EditorSelectionSource,
): boolean {
  return source === "preview" || source === "refresh" || source === "programmatic";
}

export function shouldIgnoreFigmaSelectionWhileXrSessionActive(params: {
  source: EditorSelectionSource;
  addFigmaPanelActive: boolean;
  xrEntryPanelActive: boolean;
  xrPanelSessionActive: boolean;
}): boolean {
  return (
    !params.addFigmaPanelActive &&
    params.xrPanelSessionActive &&
    isTransientFigmaSelectionSource(params.source)
  );
}

export function shouldBlockFigmaPanelPromotionWhileXrOwnsUi(params: {
  source: EditorSelectionSource;
  hasExplicitXrPanelOwnership: boolean;
}): boolean {
  return (
    params.hasExplicitXrPanelOwnership &&
    isTransientFigmaSelectionSource(params.source)
  );
}
